import React, { Component } from "react";
import { Email } from "@material-ui/icons";
import InputAdornment from "@material-ui/core/InputAdornment";
import { Link, withRouter } from "react-router-dom";
import { Loader } from "rsuite";
import { customAlert } from "../Alert/alert.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSignInAlt,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";

import Button from "../LogButton/Button";
import CustomInput from "../CustomInput/CustomInput";
import GridContainer from "../Grid/GridContainer";
import GridItem from "../Grid/GridItem";

import "./sign-up.styles.scss";
import API from "../../E2E/axios.util";

class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailId: "",
      password: "",
      isDisabled: false,
      ShowPassword: false,
    };
  }
  //handle text Change
  handleChange = (event) => {
    const { value, name } = event.target;
    this.setState({ [name]: value });
  };
  //handle Form Submission
  handleSubmit = async (event) => {
    //dataDestructure
    event.preventDefault();
    this.setState({ isDisabled: !this.state.isDisabled });
    const userData = {
      emailId: this.state.emailId,
      password: this.state.password,
    };
    //API CALL
    await API.post("/registration", userData)
      .then((User) => {
        let msg = JSON.stringify(User.data.msg);
        console.log(msg);
        if (msg === '"User already Exists"') {
          customAlert("info", "Sorry,Email Already Exists!");
        } else {
          customAlert("success", "Sign-Up Successful");
          this.props.history.push("/");
        }
        this.setState({ isDisabled: !this.state.isDisabled });
      })
      .catch((err) => {
        customAlert("error", "Sign-Up Failed");
        console.log(err.message);
        this.setState({ isDisabled: !this.state.isDisabled });
      });
  };
  //render JSX
  render() {
    return (
      <div className="sign-up">
        <span className="subTitle">Join Now</span>
        <form onSubmit={this.handleSubmit}>
          <GridContainer lg={12} sm={12} xs={12}>
            <GridItem>
              <CustomInput
                name="emailId"
                labelText="Email"
                id="material"
                onChange={this.handleChange}
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Email className="title" style={{ marginBottom: 5 }} />
                    </InputAdornment>
                  ),
                }}
                type="email"
                required
                white={true}
              />
            </GridItem>
            <GridItem>
              <CustomInput
                name="password"
                labelText="Password Shoud Be 8 Characters Long"
                id="primary"
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <FontAwesomeIcon
                        icon={!this.state.ShowPassword ? faEye : faEyeSlash}
                        style={{ cursor: "pointer", marginBottom: 5 }}
                        onClick={() =>
                          this.setState({
                            ShowPassword: !this.state.ShowPassword,
                          })
                        }
                      />
                    </InputAdornment>
                  ),
                }}
                onChange={this.handleChange}
                type={!this.state.ShowPassword ? "password" : "text"}
                white={true}
              />
            </GridItem>
            <GridItem>
              <p
                style={{
                  color: "white",
                  margin: "20px 20px",
                  fontWeight: "600",
                  fontFamily: "Montserrat",
                }}
              >
                Already Have an Accout?
                <Link style={{ color: "yellow" }} to="/">
                  {" "}
                  Click Here
                </Link>
              </p>
            </GridItem>
            <div className="buttons">
              {this.state.isDisabled ? (
                <Loader />
              ) : (
                <Button
                  type="submit"
                  disabled={this.state.password.length < 8 ? true : false}
                >
                  {" "}
                  <FontAwesomeIcon
                    icon={faSignInAlt}
                    style={{ marginRight: 10 }}
                  />
                  Sign-Up
                </Button>
              )}
            </div>
          </GridContainer>
        </form>
      </div>
    );
  }
}

export default withRouter(SignUp);
